module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [_c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cooperate-mobile"
  }, [_c('div', {
    staticClass: "dd-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cooperate-main"
  }, [_c('div', {
    staticClass: "cm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "maxlength": 8,
      "placeholder": "请输入您的姓名",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    attrs: {
      "maxlength": 100,
      "placeholder": "请输入您的公司",
      "type": "text"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "maxlength": 11,
      "placeholder": "请输入您的电话",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "maxlength": 100,
      "placeholder": "请输入您的邮箱",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "maxlength": 500,
      "placeholder": "请输入您的问题描述"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm-btn",
    on: {
      "click": _vm.sendHandle
    }
  }, [_vm._v("提交")])])]), _vm._v(" "), _c('fi-footer-mobile', {
    attrs: {
      "is-adv": false
    }
  }), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("姓名")]), _vm._v(" "), _c('p', [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("公司")]), _vm._v(" "), _c('p', [_vm._v("ITD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("电话")]), _vm._v(" "), _c('p', [_vm._v("Call")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("邮箱")]), _vm._v(" "), _c('p', [_vm._v("E-mail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("描述")]), _vm._v(" "), _c('p', [_vm._v("Brief")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e5abe9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CooperateMobile.vue
// module id = 379
// module chunks = 1